import {
	HOMEPAGE_WELCOME_MESSAGE,
	HOMEPAGE_LATEST_FEED_MESSAGE,
} from "../../common/constants";
export const stringsKey = "HomePage";
export const englishStrings = {
	welcomeMessage: HOMEPAGE_WELCOME_MESSAGE,
	latestFeedMessage: HOMEPAGE_LATEST_FEED_MESSAGE,
	errorMessage: "Failed to load home page detail!",
	loadMore: "Load more",
};
